import React from 'react';
import { FormControl, TextField } from '@material-ui/core';

import { PromotionCodeControlProps } from './PromotionCodeControl.interfaces';
import { UtilService } from 'app/services/util.service';
import { ControlContainer } from 'app/components/ControlContainer';
import { DoneAdornment } from 'app/components/DoneAdornment';
import { usePromotionCodeControl } from './usePromotionCodeControl';
import { useInputControl } from 'app/shared/hooks/controls/useInputControl';

const PromotionCodeControl = (props: PromotionCodeControlProps) => {
  const {
    disabled,
    input,
    meta,
    meta: { touched, valid },
    label,
    subLabel,
    tooltip,
    width,
    helperText,
  } = props;

  const { onFocus, handleClick } = useInputControl(props);
  const { focused, handleChange, handleBlur } = usePromotionCodeControl(props);

  return (
    <FormControl fullWidth>
      <ControlContainer
        inputId={input.name}
        meta={meta}
        width={width}
        floating
        tooltip={tooltip}
        isQuestionValid={props.isQuestionValid}
        floated={focused || UtilService.hasValue(input.value)}
        helperText={helperText}
        focused={focused}
      >
        <TextField
          {...input}
          id={input.name}
          disabled={disabled}
          InputLabelProps={{
            shrink: UtilService.hasValue(input.value) || focused,
          }}
          onChange={handleChange}
          onBlur={handleBlur}
          onClick={handleClick}
          onFocus={onFocus}
          label={subLabel ? `${label} - ${subLabel}` : label}
          fullWidth
          InputProps={{
            startAdornment: !focused && UtilService.hasValue(input.value) && (
              <DoneAdornment />
            ),
          }}
          error={touched && !valid}
          variant={'outlined'}
          margin={'dense'}
        />
      </ControlContainer>
    </FormControl>
  );
};

export default PromotionCodeControl;
